import React, { useEffect, useMemo, useRef, useState } from 'react';

import { Button, Container, Grid, Typography } from '@material-ui/core';

import EditFields from '../common/EditFields';

export default ({ study, onSave, onCancel }) => {
  const [data, setData] = useState({ study });
  useEffect(() => {
    setData({ study });
  }, [study]);
  const ref = useRef();
  const onSaveClick = () => {
    const validData = ref.current.getValidData();
    if (validData) {
      onSave(validData.study);
    }
  };
  const field = useMemo(() => [{ label: 'Current title', name: 'study', required: true, type: 'text', variant: 'standard' }], []);
  return (
    <Grid container component={Container} className="py-3" style={{ width: '21rem' }}>
      <Grid item>
        <Typography className="page-header mb-1">Change Study Title</Typography>
      </Grid>
      <Grid item className="mb-2">
        <EditFields data={data} labelPosition="top" ref={ref} fields={field} />
      </Grid>
      <Grid item container justify="space-between">
        <Button variant="outlined" style={{ width: '140px' }} color="primary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" style={{ width: '140px' }} onClick={onSaveClick}>
          Save New Title
        </Button>
      </Grid>
    </Grid>
  );
};
